import React, { useEffect, useState } from "react";
import { FormDropDown } from "./dropdown";
import { url } from "../../config";
import axios from "axios";
import { useFormikContext } from "formik";

const CountryCityLocalityInput = () => {
  const { values } = useFormikContext();

  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [localityList, setLocalityList] = useState([]);

  // Country API
  const countryListFnc = async () => {
    try {
      const res = await axios.post(`${url}/dropdown/country-list`);

      const newArr = res?.data?.data?.countries?.map((ele) => ({
        label: ele.name,
        value: ele.id,
      }));

      setCountryList(newArr);
    } catch (err) {
      console.error(err);
    }
  };

  // City API
  const cityListFnc = async (countryId) => {
    try {
      const res = await axios.post(`${url}/dropdown/city-list`, {
        country_city_id: countryId,
      });

      const newArr = res?.data?.data?.cities?.map((ele) => ({
        label: ele.name,
        value: ele.id,
      }));

      setCityList(newArr);
    } catch (err) {
      console.error(err);
    }
  };

  // Locality API
  const localityListFnc = async (cityId) => {
    try {
      const res = await axios.post(`${url}/dropdown/locality-list`, {
        city_id: cityId,
      });

      const newArr = res?.data?.data?.localities?.map((ele) => ({
        label: ele.main_location,
        value: ele.id,
      }));

      setLocalityList(newArr);
    } catch (err) {
      console.error(err);
    }
  };

  // Load Countries
  useEffect(() => {
    countryListFnc();
  }, []);

  // When Country changes → load cities
  useEffect(() => {
    if (values.country_city_id) {
      cityListFnc(values.country_city_id);
    }
  }, [values.country_city_id]);

  // When City changes → load localities
  useEffect(() => {
    if (values.city_id) {
      localityListFnc(values.city_id);
    }
  }, [values.city_id]);

  console.log(values, "values");

  return (
    <div>
      <div className="my-5">
        <FormDropDown
          name="country_city_id"
          label="Country"
          options={countryList}
          value={countryList?.find(
            (item) => item?.value === values?.country_city_id,
          )}
          placeholder={"Select country"}
        />
      </div>

      <div className="my-5">
        <FormDropDown
          name="city_id"
          label="City"
          options={cityList}
          value={cityList?.find((item) => item?.value === values?.city_id)}
          placeholder={"Select city"}
        />
      </div>

      <div className="my-5">
        <FormDropDown
          name="locality_id"
          label="Locality"
          options={localityList}
          value={localityList?.find(
            (item) => item?.value === values?.locality_id,
          )}
          placeholder={"Select locality"}
        />
      </div>
    </div>
  );
};

export default CountryCityLocalityInput;
